import H5 from "../../ui/Typography/Headings/H5";
import React from "react";
import getProfessionFieldSelector from "../../../../state/selectors/ProfessionSelectors/getProfessionFieldSelector";
import styled from "styled-components";
import { useSelector } from "react-redux";

const ProfessionAttachements: React.FC = () => {
    const attachments = useSelector((state: Store) => getProfessionFieldSelector(state, "attachments"));
    const downloadResource = (url: string, name: string) => {
        fetch(url)
            .then(response => response.blob())
            .then(blob => {
                const blobURL = URL.createObjectURL(blob);
                const a: any = document.createElement("a");
                a.href = blobURL;
                a.style = "display: none";

                if (name && name.length) a.download = name;
                a.click();
            })
            .catch(e => console.error(e));
    };
    if (!attachments) return null;
    return (
        <Wrapper>
            <H5>Allegati</H5>
            <Ul>
                {attachments.map(({ title, url }: GenericObject) => (
                    <li key={url + title}>
                        <A
                            onClick={e => {
                                e.preventDefault();
                                downloadResource(url, title);
                            }}
                        >
                            {title}
                        </A>
                    </li>
                ))}
            </Ul>
        </Wrapper>
    );
};

export default ProfessionAttachements;

const Wrapper = styled.div`
    padding: 0.5rem;
    margin-top: 1rem;
    @media print {
        display: none;
    }
`;

const Ul = styled.ul`
    list-style: none;
    padding-left: 0;
`;

const A = styled.a`
    text-decoration: none;
    color: ${props => props.theme.colors.primary(1)};
    font-weight: 400;
    cursor: pointer;
    &:hover {
        text-decoration: underline;
    }
`;
